import React, {Children, cloneElement, useState} from 'react';

import Button from '../Button/Button';
import Snackbar from '../Snackbar/Snackbar';

import style from './Form.module.scss';

const Form = ({form, onSubmit, children}) => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccess(false);
        setError(false);
        try {
            await onSubmit(form.data);
            setSuccess(true)
            form.resetForm();
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
        
    }

    const createFields = (elements) => {
        return Children.map(elements, (el) => {
            if (!React.isValidElement(el)) return el;

            if (el.props.children) {
                return cloneElement(el, {children: createFields(el.props.children)})
            }

            return cloneElement(el, {value: form.data[el.props.name], onChange: form.handleChange});
        })
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                {createFields(children)}

                <Button className={style.submitButton} loading={loading}>Изпрати</Button>
            </form>
            {success ? <Snackbar message="Благодарим! Успешно получихме твоя отговор." variant='success' /> : undefined}
            {error ? <Snackbar message="Нещо се обърка! Не успяхме да получим твоя отговор. Опитай пак след малко." variant='error' /> : undefined}
        </>
    )
}

export default Form;
